import { render, staticRenderFns } from "./survey_comments.vue?vue&type=template&id=581e49ec&scoped=true&"
import script from "./survey_comments.vue?vue&type=script&lang=js&"
export * from "./survey_comments.vue?vue&type=script&lang=js&"
import style0 from "./survey_comments.vue?vue&type=style&index=0&id=581e49ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e49ec",
  null
  
)

export default component.exports